import React, { useState, useRef, useEffect } from 'react'
import { Input, notification } from 'antd'
import AddProductCart from '../../../services/addProductCart.service'
import ModalSearchProductList from './ModalSearchProductList'
import ModalProduct from '../AddProductFromLink/ModalProduct'

interface Props {
    t: any
    setLoading?: Function
    loadData: Function
    loadingCallData: any
}

const { Search } = Input

const SearchProductByKeyword: React.FC<Props> = (props: Props) => {
    const { t, loadData, loadingCallData } = props

    const [keyword, setKeyword] = useState<string>('')
    const [marketplace, setMarketplace] = useState<string>('taobao')
    const [searching, setSearching] = useState<boolean>(false)
    const [products, setProducts] = useState<any[]>([])
    const [openModalList, setOpenModalList] = useState<boolean>(false)

    // Modal chi tiết sản phẩm cũ (kế thừa ModalProduct & Product1688)
    const [openModalDetail, setOpenModalDetail] = useState<boolean>(false)
    const [selectedProductLink, setSelectedProductLink] = useState<string>('')

    const debounceTimerRef = useRef<any>(null)

    // Dọn dẹp timer khi unmount
    useEffect(() => {
        return () => {
            if (debounceTimerRef.current) {
                clearTimeout(debounceTimerRef.current)
            }
        }
    }, [])

    const triggerSearch = (kw: string) => {
        if (!kw || !kw.trim()) return

        setSearching(true)
        AddProductCart.searchSourcingProducts(
            { keyword: kw.trim(), marketplace },
            (err: any, res: any) => {
                setSearching(false)
                if (err) {
                    notification.error({
                        message: t('message.error') || 'Có lỗi xảy ra khi tìm kiếm sản phẩm',
                    })
                    return
                }

                const data = res?.data || res
                const list = Array.isArray(data)
                    ? data
                    : Array.isArray(data?.items)
                        ? data.items
                        : Array.isArray(data?.products)
                            ? data.products
                            : []

                setProducts(list)
                setOpenModalList(true)

                if (list.length === 0) {
                    notification.info({
                        message: t('cart.search_product_empty') || 'Không tìm thấy sản phẩm phù hợp',
                    })
                }
            }
        )
    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const val = e.target.value
        setKeyword(val)

        if (debounceTimerRef.current) {
            clearTimeout(debounceTimerRef.current)
        }

        // Debounce khoảng 3s (3000ms) khi người dùng nhập từ khóa
        if (val && val.trim().length >= 2) {
            debounceTimerRef.current = setTimeout(() => {
                triggerSearch(val)
            }, 1500)
        }
    }

    const handleSearch = (value?: string) => {
        const query = value !== undefined ? value : keyword
        if (debounceTimerRef.current) {
            clearTimeout(debounceTimerRef.current)
        }
        if (query && query.trim()) {
            triggerSearch(query)
        }
    }

    const handleSelectProduct = (item: any) => {
        const miId = item.mi_id || item.miId || item.raw?.mi_id || item.raw?.miId
        const itemId = item.itemId || item.id || item.oid || item.offerId

        let link = ''
        // Ưu tiên 1: Lấy mi_id để tạo link mở modal chi tiết sản phẩm
        if (miId) {
            link =
                item.raw?.taoworld_url ||
                `https://distributor.taobao.global/apps/source/detail?mi_id=${encodeURIComponent(miId)}`
        } else if (item.itemUrl || item.url || item.detailUrl) {
            link = item.itemUrl || item.url || item.detailUrl
        } else if (itemId) {
            link = `https://item.taobao.com/item.htm?id=${itemId}`
        }

        if (link) {
            setSelectedProductLink(link)
            setOpenModalDetail(true)
        } else {
            notification.warning({
                message: 'Không tìm thấy đường dẫn sản phẩm hợp lệ',
            })
        }
    }

    const handleClearDetail = () => {
        setOpenModalDetail(false)
        setSelectedProductLink('')
        loadingCallData()
    }

    const handleCloseModalList = () => {
        setOpenModalList(false)
        setKeyword('')
        setProducts([])
        if (debounceTimerRef.current) {
            clearTimeout(debounceTimerRef.current)
        }
    }

    return (
        <>
            <Search
                placeholder={`${t('cart.search_product_by_keyword') || 'Tìm kiếm sản phẩm Taobao theo từ khóa'}...`}
                allowClear
                size="large"
                onChange={handleChange}
                onSearch={handleSearch}
                loading={searching}
                style={{ width: '100%', borderRadius: '12px' }}
                enterButton
                value={keyword}
            />

            {/* Modal danh sách sản phẩm tìm kiếm */}
            {openModalList && (
                <ModalSearchProductList
                    open={openModalList}
                    onClose={handleCloseModalList}
                    keyword={keyword}
                    marketplace={marketplace}
                    products={products}
                    loading={searching}
                    t={t}
                    onSelectProduct={handleSelectProduct}
                />
            )}

            {/* Modal chi tiết sản phẩm kế thừa ModalProduct có sẵn */}
            {openModalDetail && selectedProductLink && (
                <ModalProduct
                    link={selectedProductLink}
                    openModal={openModalDetail}
                    handleModal={() => setOpenModalDetail(false)}
                    t={t}
                    loadData={loadData}
                    handleClear={handleClearDetail}
                />
            )}
        </>
    )
}

export default SearchProductByKeyword
